module.exports = __webpack_public_path__ + "static/img/rccola.3a01db3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/rccola.png
// module id = yth4
// module chunks = 0